module.exports = __webpack_public_path__ + "static/media/mainImg1.a33a93c7.jpeg";